<template>

    <div class="container">

        <app-head title="Pages" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Pages') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.pages.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="publish_status" v-model="form.publish_status">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="k" v-for="(v, k) in publishStatusOptions">{{ v }}</option>
                </select-input>
                <select-input label="Status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="pages.meta" />
        </div>

        <div class="card">
            <data-table :items="pages.data"
                        :links="pages.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="page in pages.data" :key="page.id">
                    <td>
                        {{ page.id }}
                    </td>
                    <td>
                        <div v-if="page.deleted_at">
                            {{ page.title }}
                        </div>
                        <inertia-link class="stretched-link" :href="route('admin.pages.edit', page)" v-else>
                            {{ page.title }}
                        </inertia-link>
                    </td>
                    <td>
                        <!--@todo Colorized badges-->
                        {{ page.publish_status || '-' }}
                    </td>
                    <td>
                        {{ page.created_at | localizeDateTime }}
                    </td>
                    <td class="text-end">
                        <template v-if="page.deleted_at">
                            <button type="button" class="btn btn-outline-success" @click="restore(page)">
                                {{ __('Restore') }}
                            </button>
                            <button type="button" class="btn btn-outline-danger" @click="destroyPermanently(page)">
                                {{ __('Destroy permanently') }}
                            </button>
                        </template>
                        <template v-else>
                            <i class="bi bi-chevron-right"></i>
                        </template>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Results from '@/shared/Admin/Results';

    export default {
        props: [
            'filters',
            'pages',
            'publishStatusOptions',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    publish_status: this.filters.publish_status,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    title: {label: 'Title', sortable: 'title'},
                    publish_status: {label: 'Publish status', sortable: 'publish_status'},
                    created_at: {label: 'Created', sortable: 'created_at'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.pages.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
            destroyPermanently(page) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.pages.destroy-permanently', page.id));
                }
            },
            restore(page) {
                this.$inertia.get(this.route('admin.pages.restore', page.id));
            },

        },
    }
</script>